import { createApi } from '@reduxjs/toolkit/query/react';
import { IPagedCollection, TaskDto, CreateTaskDto, UpdateTaskDto, TaskStatusEnum } from '@sr/dto';
import { CollectionParams, createBaseQuery } from 'shared/api/rtk-query';
import { pagingDataToParams } from 'utils/remote-paged-collection.hook';

export const tasksApi = createApi({
  reducerPath: 'tasks',
  baseQuery: createBaseQuery('tasks'),
  tagTypes: ['tasks'],
  endpoints: (builder) => ({
    getTasksPaged: builder.query<IPagedCollection<TaskDto>, Required<CollectionParams>>({
      query: ({ paging, filter }) => ({ url: `?${filter ?? ''}`, params: paging && pagingDataToParams(paging) }),
      providesTags: (result) => (result ? ['tasks'] : []),
    }),
    getTask: builder.query<TaskDto, number>({
      query: (id) => ({ url: `${id}` }),
      providesTags: (result, error, id) => [{ type: 'tasks', id }],
    }),
    createTask: builder.mutation<TaskDto, CreateTaskDto>({
      query: (dto) => ({ url: '', method: 'POST', body: dto }),
      invalidatesTags: ['tasks'],
    }),
    updateTask: builder.mutation<TaskDto, { id: number } & UpdateTaskDto>({
      query: ({ id, ...dto }) => ({ url: `${id}`, method: 'PUT', body: dto }),
      invalidatesTags: (result, error, arg) => [{ type: 'tasks', id: arg.id }, 'tasks'],
    }),
    updateTasksStatusBulk: builder.mutation<{ updated: number }, { ids: number[]; status: TaskStatusEnum }>({
      query: (dto) => ({ url: 'bulk-status', method: 'PUT', body: dto }),
      invalidatesTags: ['tasks'],
    }),
  }),
});
